<template>
  <div>
    <page-title title="Help" />
    <hr />
    
    <content-block slug="subscriber-help" />
  </div>
</template>

<script>
export default {
  name: 'SubscriberHelp',
  props: {
  }
}
</script>